import React from 'react';
import { View } from 'react-native';
import type { LeaveBalance } from '@hrms/shared';
import { Card, Dot, Grid, Text } from '../../../ui';

export function BalanceCards({ balances }: { balances: LeaveBalance[] }) {
  return (
    <Grid min={220}>
      {balances.map((b) => (
        <Card key={b.id}>
          <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 6, flex: 1 }}>
              <Dot color={b.leave_type.color} />
              <Text weight="semibold" numberOfLines={1}>
                {b.leave_type.name}
              </Text>
            </View>
            <Text variant="small">{b.leave_type.code}</Text>
          </View>
          <Text size={30} weight="bold" style={{ marginVertical: 6 }}>
            {b.balance}
          </Text>
          <View style={{ flexDirection: 'row', flexWrap: 'wrap', rowGap: 6 }}>
            {(
              [
                ['Opening', b.opening],
                ['Accrued', b.accrued],
                ['Used', b.used],
                ['Pending', b.pending],
                ['Lapsed', b.lapsed],
                ['Encashed', b.encashed],
              ] as const
            ).map(([k, v]) => (
              <View key={k} style={{ width: '33.33%' }}>
                <Text variant="small">{k}</Text>
                <Text weight="semibold" size={13}>
                  {v}
                </Text>
              </View>
            ))}
          </View>
        </Card>
      ))}
    </Grid>
  );
}
